/* global axios */
import ApiClient from './ApiClient';

class TaskTemplatesAPI extends ApiClient {
  constructor() {
    super('task_templates', { accountScoped: true });
  }
  list() { return axios.get(this.url); }
  create(payload) { return axios.post(this.url, payload); }
  update(id, payload) { return axios.patch(`${this.url}/${id}`, payload); }
  remove(id) { return axios.delete(`${this.url}/${id}`); }
  apply(id, overrides = {}) { return axios.post(`${this.url}/${id}/apply`, overrides); }
}

export default new TaskTemplatesAPI();
